import React from 'react';
import { NavLink } from 'react-router-dom';
import './EmailMobile.css';

import FlipCard from '../../../components/FlipCards/FlipCard';

const emailMobile = ( props ) => {
	const card = {
		side1: 'Mobile',
		side2: '<p><strong>Pro Tip:</strong></p><p>This is handy for a quick email check the day before you return from PTO so you aren\'t surprised by an early meeting!</p>',
		icon: 'communication.phone',
		side2class: 'bg-color-1'
	}
	return (
		<section id="EmailMobile" className="section">
			<FlipCard className="bg-gradient vertical invert" { ...card } />
			<div className="inner-section">
				<p>
					Waiting on an important email, but also really want that McRib before it's gone again?
				</p>
				<p>
					You can get your IDSI email on your mobile device for quick access and to help increase responsiveness! Note: This is not a requirement! Everyone at IDSI deserves the right and is encouraged to disengage from work in their free time.
				</p>
				<p>
				Setting up email on your mobile device is easy!  Add a new Corporate (Apple devices) or Exchange (Android) account.  All you should need is your IDSI email address and password.  If you have any trouble, just ask 
				{ ' ' }
				<a href="mailto:Magill.Michael@idsi.com">Michael Magill</a>.
				</p>
			</div>
		</section>
	);
};

export default emailMobile;



// WEBPACK FOOTER //
// ./src/pages/Communication/EmailMobile/EmailMobile.js